<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
          xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-nav="false">
    <div class="page-container">
      <div class="content-card bg-white">
        <div class="toolbar flex a-center">
          <Button @click="createConsultShow" class="m-l-25 btn-primary" type="primary">新增咨询</Button>
          <Input v-model="searchText"
                 clearable
                 @on-clear="onGetConsultList"
                 @on-enter="onGetConsultList"
                 class="m-l-15 search-input" placeholder="搜索咨询名称"/>
          <Button @click="onGetConsultList" class="m-l-15 btn-search">搜索</Button>
        </div>

        <div class="table-wrapper">
          <Table :columns="columns" :data="dataList">

            <template v-slot:copy="{row}">
              <div class="flex a-center">
                <i class="icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                   v-clipboard:copy="row.url"
                   v-clipboard:error="onError"
                   v-clipboard:success="copy"/>
              </div>
            </template>

            <template v-slot:link="{row}">
              <div class="flex a-center j-center link-cell">
                {{ row.url }}
              </div>
            </template>

            <template v-slot:operation="{row,index}">
              <div class="operation-btns">
                <span @click="editConsult(row)" class="op-btn edit">
                  <i class="iconfont icon-edit"></i> 编辑
                </span>
                <span @click="onAnswerClick(row,index)" class="op-btn record">
                  <i class="iconfont icon-record"></i> 记录
                </span>
                <span @click="onDelConsult(row,index)" class="op-btn delete">
                  <i class="iconfont icon-delete"></i> 删除
                </span>
                <span :style="{color: getStatus(row)}" @click="changeStatus(row,index)" class="op-btn toggle">
                  <i class="iconfont" :class="row.status === 1 ? 'icon-pause' : 'icon-publish'"></i>
                  {{ row.status === 1 ? '停用' : '发布' }}
                </span>
              </div>
            </template>

            <template v-slot:status="{row}">
              <div class="flex a-center j-center">
                <span class="status-tag" :class="row.status === 1 ? 'published' : 'draft'">
                  {{ row.status === 1 ? '已发布' : '未发布' }}
                </span>
              </div>
            </template>
          </Table>

          <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize"
                :total="tablePage.total"
                class="pagination m-t-10 p-b-10"
                show-total
                show-sizer/>
        </div>
      </div>
    </div>

    <!--    重置名称弹框-->
    <Modal
        :closable="false"
        class="modal-setting"
        title=" "
        v-model="renameModal.show"
        width="400px"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>

      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
      <!--      <div style="width: 400px" class="flex j-center a-center m-b-20">-->
      <Input class=" m-b-10"
             style="width: 320px" v-model="renameModal.name"/>
      <!--      </div>-->

    </Modal>

    <!--    新建页面弹框-->
    <Modal
        :closable="false"
        class="modal-setting"
        title=" "
        v-model="createConsultModal.show"
        width="400px"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>{{ createConsultModal.title }}</span>
      </p>
      <p slot="footer"></p>

      <div>
        <Input class=" m-b-10"
               placeholder="咨询名称" style="width: 320px" v-model="createConsultModal.consultName"/>
        <div class="w-full flex j-center">
          <Button @click="createConsultModal.show= false">取消</Button>
          <Button @click="onAddConsult" style="margin-left: 50px" type="primary">
            确定
          </Button>
        </div>
      </div>

    </Modal>

    <CousultEditModal
        ref="consultEditModal"
    />
  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {mapActions} from 'vuex'
import CousultEditModal from '@/views/basesettings/ConsultEditModal'


export default {
  name: 'ConsultList',
  components: {
    CousultEditModal,
    BasePageComponent,
    UpLoadImage,
  },
  data () {
    return {
      tableHeight: 620,
      totalPage: 99,
      pageSize: 20,
      pageNum: 1,
      searchText: '',
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      renameModal: {
        show: false,
        title: '重置名称',
        name: '',
        row: {},
      },
      createConsultModal: {
        show: false,
        title: '新建咨询',
        consultName: '',
      },
      columns: [
        {
          title: '名称',
          key: 'name',
          minWidth: 160,
          tooltip: true
        }, {
          title: '收集份数',
          key: 'collectCount',
          width: 200,
          align: 'center',
          tooltip: true
        }, {
          title: '状态',
          slot: 'status',
          width: 200,
          align: 'center',
          tooltip: true
        },


        {
          title: '操作',
          slot: 'operation',
          width: 360
        }
      ],
      dataList: [],
      //咨询默认信息
      ConsultSettingList: [
        {
          id: 0,
          type: 1,
          //提示文字
          name: '姓名',
          //是否显示行
          isShow: 1,
        },
        {
          id: 0,
          type: 2,
          name: '联系电话',
          isShow: 1,
        },
        {
          id: 0,
          type: 3,
          name: '单位',
          isShow: 1,
        },
        {
          id: 0,
          type: 4,
          name: '微信',
          isShow: 1,
        },
        {
          id: 0,
          type: 5,
          name: '邮箱',
          isShow: 1,
        },
        {
          id: 0,
          type: 6,
          name: '地址',
          isShow: 1,
        },
        {
          id: 0,
          type: 7,
          name: '留言',
          isShow: 1,
        },
        {
          id: 0,
          type: 8,
          name: '自定义',
          isShow: 0,
        },
      ]
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.onGetConsultList()
  },
  methods: {
    init () {
      this.onGetConsultList()
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    getStatus (row) {
      if (row.status === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    editConsult (row) {
      this.$refs.consultEditModal.show(row.id)
    },
    onAnswerClick (row) {
      this.$router.push({
        path: '/answerlist',
        query: {
          consultId: row.id
        }
      })
    },

    toRenovation () {
      const {href} = this.$router.resolve({
        path: '/renovation',
        query: {
          title: this.createConsultModal.consultName,
          from: 'GuidePage',
        }
      })
      window.open(href, 'guidepage')
    },

    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        row: row,
      }
    },

    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      this.renameModal.show = false
      this.renameModal.row.name = this.renameModal.name
    },
    //删除页面
    onDelConsult (row, index) {
      const content = '<p>确定要删除 ' + row.name + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let params = {
            idList: row.id
          }
          this.delConsult(params).then(res => {
            if (res.code === 0) {
              this.onGetConsultList()
            }
          })
        },
        onCancel: () => {
        }
      })
    },

    //停用 发布页面
    changeStatus (row, index) {
      const operator = row.status === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal.confirm({
        title: '提示',
        content: '确定要' + operator + ' ' + page + ' 吗?',
        onOk: () => {
          let params = {
            isEnable: row.status === 1 ? 0 : 1
          }
          this.editConsultDetail({id: row.id, params}).then(res => {
            if (res.code === 0) {
              this.onGetConsultList()
            }
          })
        },
        onCancel: () => {
        }
      })
    },


    /**
     * 获取咨询列表
     */
    onGetConsultList () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchText) {
        params.name = this.searchText
      }
      this.getConsultList(params).then(res => {
        if (res.code === 0) {
          let dataList = res.data.list
          if (res.data && dataList) {
            dataList.forEach(item => {
              item.status = item.isEnable
            })
            this.dataList = dataList
          }
          this.tablePage.total = res.data.total || 0
          this.createConsultModal.show = false
        }
      })
    },

    /**
     * 显示弹框
     */
    createConsultShow () {
      this.createConsultModal.consultName = ''
      this.createConsultModal.show = true
    },

    /**
     * 添加咨询
     */
    onAddConsult () {
      let consultName = this.createConsultModal.consultName
      if (consultName) {
        let params = {
          name: consultName,
          settingList: this.ConsultSettingList
        }
        //添加zgh
        this.addConsult(params).then(res => {
          if (res.code === 0) {
            //刷新列表
            this.onGetConsultList()
          }
        })


      } else {
        this.$Message.info('名称不能为空')
      }
    },

    ...mapActions([
      'getConsultList',
      'addConsult',
      'delConsult',
      'editConsultDetail',
    ])
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #F4F8FF;
  height: 100%;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.content-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.toolbar {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;

  .btn-primary {
    background: #3B80FF;
    border-color: #3B80FF;
    border-radius: 4px;

    &:hover {
      background: #2b6ee8;
      border-color: #2b6ee8;
    }
  }

  .search-input {
    width: 240px;

    :deep(.ivu-input) {
      border-radius: 4px;
    }
  }

  .btn-search {
    background: #fff;
    border: 1px solid #dcdee2;
    border-radius: 4px;

    &:hover {
      color: #3B80FF;
      border-color: #3B80FF;
    }
  }
}

.table-wrapper {
  padding: 16px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  ::v-deep {
    .ivu-table-wrapper {
      flex: 1;
      overflow: auto;
    }

    .ivu-table {
      font-size: 14px;
    }

    .ivu-table-header th {
      background: #f8f9fb;
      color: #333;
      font-weight: 600;
    }
  }
}

.link-cell {
  color: #666;
  font-size: 13px;
}

.operation-btns {
  display: flex;
  align-items: center;
  justify-content: center;

  .op-btn {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-size: 13px;
    padding: 4px 10px;
    border-radius: 4px;
    transition: all 0.2s ease;
    margin: 0 4px;

    i {
      margin-right: 4px;
      font-size: 14px;
    }

    &.edit, &.record {
      color: #3B80FF;
      background: rgba(59, 128, 255, 0.08);

      &:hover {
        background: rgba(59, 128, 255, 0.15);
        color: #2b6ee8;
      }
    }

    &.delete {
      color: #ed4014;
      background: rgba(237, 64, 20, 0.08);

      &:hover {
        background: rgba(237, 64, 20, 0.15);
        color: #c51c0f;
      }
    }

    &.toggle {
      font-weight: 500;
      background: rgba(0, 0, 0, 0.04);

      &:hover {
        background: rgba(0, 0, 0, 0.08);
      }
    }
  }
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 11px;
  font-size: 13px;

  &.published {
    background-color: #EEFFEF;
    color: #4CAF50;
  }

  &.draft {
    background-color: #FFF3EB;
    color: #ed4014;
  }
}

.pagination {
  text-align: right;
  padding: 16px;
  background: #fff;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;

  ::v-deep {
    .ivu-page-total {
      float: left;
      line-height: 32px;
      font-size: 14px;
      color: #666;
    }

    .ivu-page {
      float: right;
    }
  }
}

.modal-setting ::v-deep {
  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .ivu-modal-header {
    border-bottom: none;
  }

  .ivu-modal-footer {
    border-top: none;
  }
}
</style>
